import React, { Component } from "react";
import {
  Typography,
  Grid,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControlLabel,
  MuiThemeProvider
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { ReactPainter } from "react-painter";

import DisplayGameObject from "./DisplayGameObject";
import { isSmallScreen } from './Utils';

class PlayerPrompt extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lineWidth: 5,
            lineCap: "round",
            promptData: ""
        };
        this.canvasReferer = React.createRef();
    };

    setLineWidthState = (lineWidth) => {
        this.setState({lineWidth});
    };

    setLineCapState = (lineCap) => {
        this.setState({lineCap});
    };

    clearCanvas = () => {
        this.canvasReferer.current.children[0].width = this.canvasReferer.current.children[0].width;
    };

    sendSubmissionItem = (item) => {
        if (item instanceof Blob)
        {
            this.props.submitTurn(item);
        }
        else
        {
            this.props.submitTurn(this.state.promptData);
        }
    };

    handleChange = (e) => {
        this.setState({promptData: e.target.value});
    };

    componentDidMount = () => {
        if (this.canvasReferer.current)
        {
            let canvasElement = this.canvasReferer.current.children[0];

            // Prevent scrolling when touching the canvas
            canvasElement.addEventListener("touchstart", function (e) {
                    e.preventDefault();
            }, false);
            canvasElement.addEventListener("touchend", function (e) {
                    e.preventDefault();
            }, false);
            canvasElement.addEventListener("touchmove", function (e) {
                    e.preventDefault();
            }, false);
        }
    };

    render()
    {
        return (
            <MuiThemeProvider theme={this.props.theme}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                    <Typography variant="h6">
                        {this.props.currentRoundType === "prompt"
                        ? this.props.currentRoundIndex <= 0
                            ? "Write a prompt for the next player to draw! It can be anything!"
                            : "Guess the prompt for this drawing!"
                        : "Draw the prompt!"}
                    </Typography>
                    </Grid>
                    <DisplayGameObject theme={this.props.theme} lastRoundData={this.props.lastRoundData} />
                    {this.props.currentRoundType === "draw" ? (
                    <Grid item xs={12}>
                        <ReactPainter
                        width={300}
                        height={500}
                        onSave={(e) => {
                            this.sendSubmissionItem(e);
                        }}
                        render={({
                            getCanvasProps,
                            triggerSave,
                            setColor,
                            setLineCap,
                            setLineWidth
                        }) => (
                            <div style={{ margin: "auto" }}>
                            <div
                                style={{
                                    border: "1px solid",
                                    backgroundColor: "lightgrey"
                                }}
                                ref={this.canvasReferer}
                            >
                                <canvas
                                    {...getCanvasProps({
                                        ref: ref => (this.canvasRef = ref)
                                    })}
                                    style={{ backgroundColor: "white" }}
                                />
                            </div>
                            <FormControlLabel
                                style={{ float: "left", marginLeft: 5 }}
                                control={
                                <input
                                    type="color"
                                    style={{ float: "left" }}
                                    onChange={e => setColor(e.target.value)}
                                />
                                }
                                label="Color"
                                labelPlacement="top"
                            />
                            <FormControlLabel
                                style={{ float: "left", marginLeft: 5 }}
                                control={
                                <Select
                                    onChange={e => {
                                    this.setLineCapState(e.target.value);
                                    setLineCap(e.target.value);
                                    }}
                                    value={this.state.lineCap}
                                >
                                    <MenuItem value="round">Round</MenuItem>
                                    <MenuItem value="butt">Butt</MenuItem>
                                    <MenuItem value="square">Square</MenuItem>
                                </Select>
                                }
                                label="Shape"
                                labelPlacement="top"
                            />
                            <FormControlLabel
                                style={{ float: "left", marginLeft: 5 }}
                                control={
                                <Select
                                    onChange={e => {
                                    this.setLineWidthState(e.target.value);
                                    setLineWidth(e.target.value);
                                    }}
                                    value={this.state.lineWidth}
                                >
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={5}>5</MenuItem>
                                    <MenuItem value={10}>10</MenuItem>
                                    <MenuItem value={20}>20</MenuItem>
                                </Select>
                                }
                                label="Size"
                                labelPlacement="top"
                            />
                            <Button
                                style={{float: "left", marginLeft: 5, marginTop: 5}}
                                color="secondary"
                                variant="contained"
                                onClick={this.clearCanvas}
                            >
                                Clear
                            </Button>
                            <Grid item xs={12}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    style={{ float: "right", marginTop: 10 }}
                                    onClick={triggerSave}
                                    fullWidth={isSmallScreen()}
                                >
                                    Submit
                                </Button>
                            </Grid>
                            </div>
                        )}
                        />
                    </Grid>
                    ) : (
                    <Grid item xs={12}>
                        <TextField
                            autoFocus
                            label="Prompt"
                            onChange={this.handleChange}
                            value={this.state.promptData}
                            onKeyDown={(e) => {e.keyCode === 13 && this.state.promptData.length > 0 && this.sendSubmissionItem()}}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ float: "right", marginTop: 10 }}
                            onClick={this.sendSubmissionItem}
                            fullWidth={isSmallScreen()}
                        >
                            Submit
                        </Button>
                    </Grid>
                    )}
                </Grid>
            </MuiThemeProvider>
        );
    };
};

const styles = theme => ({});

export default withStyles(styles)(PlayerPrompt);